'use client';

import Link from 'next/link';
import {usePathname} from 'next/navigation';
import React, { Fragment } from 'react';
import styles from './BreadCrumb.module.scss';
import {IPagesMap, pagesMap} from "@/lib/constants/page";
import {Container} from "@/new/components/Container/Container";
import {ChevronRightIcon} from "lucide-react";


export interface IBreadCrumb {
  pageMap?: IPagesMap[] | IPagesMap | null;
}

export function BreadCrumb({pageMap}: IBreadCrumb): React.JSX.Element {
  const breadCrumb = [
    ...(Array.isArray(pageMap) ? pageMap : [pageMap]),
    ...pagesMap
  ];

  const pathname = usePathname();
  const pathSegments = pathname.split('/').filter(Boolean);

  if (pathname === '/') {
    return (<></>);
  }

  return (
    <Container>
      <nav className={styles.nav} aria-label="breadcrumb">
        <ol>
          {/*<li>*/}
          {/*  <Link href={'/'}>Главная</Link>*/}
          {/*</li>*/}
          {pathSegments.map((path, index) => {
            // Определим текущий путь сегмента
            const routeTo = `/${pathSegments.slice(0, index + 1).join('/')}`;

            // Логика скрытия: если текущий сегмент 'articles' и предыдущий — 'blog' или 'news'
            const shouldHide =
              path === 'articles' &&
              ['blog', 'news'].includes(pathSegments[index - 1]);

            if (shouldHide) return null;

            // Поиск названия по карте
            const name =
              breadCrumb.find(p => p?.href === `/${path}`)?.name || path;

            return (
              <Fragment key={routeTo + name}>
                <li>
                  <div className={styles.img}>
                    <ChevronRightIcon size={14} strokeWidth={3} color={'#29292995'}/>
                  </div>
                </li>
                <li>
                  <Link href={routeTo}>{name}</Link>
                </li>
              </Fragment>
            );
          })}
        </ol>
      </nav>
    </Container>
  );
}
